import React from 'react';
import styled from 'styled-components';

const MainBox = styled.div`
  & .MuiButton-root {
    border-color: #bbb !important;
  }
  & .MuiButtonBase-root {
    font-size: 12px;
  }
`;

interface ITabPanel {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export default function TabPanel(props: ITabPanel): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <MainBox
      style={{padding: 0}}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </MainBox>
  );
}